import { apiClient } from './api'

export interface ProjectCommunicationItem {
  id: number
  project_id: number
  stakeholder: string
  information_required: string | null
  frequency: string | null
  format: string | null
  owner: string | null
  risk_level: string | null
  last_communication: string | null
  next_due: string | null
  position: number
  created_at: string | null
  updated_at: string | null
}

export interface ProjectCommunicationCreate {
  stakeholder: string
  information_required?: string | null
  frequency?: string | null
  format?: string | null
  owner?: string | null
  risk_level?: string | null
  last_communication?: string | null
  next_due?: string | null
  position?: number
}

export const projectCommunicationsService = {
  list(projectId: number): Promise<ProjectCommunicationItem[]> {
    return apiClient.get(`/api/v1/projects/${projectId}/communications/`).then((r) => r.data)
  },
  create(projectId: number, body: ProjectCommunicationCreate): Promise<ProjectCommunicationItem> {
    return apiClient.post(`/api/v1/projects/${projectId}/communications/`, body).then((r) => r.data)
  },
  get(projectId: number, itemId: number): Promise<ProjectCommunicationItem> {
    return apiClient.get(`/api/v1/projects/${projectId}/communications/${itemId}`).then((r) => r.data)
  },
  update(projectId: number, itemId: number, body: Partial<ProjectCommunicationCreate>): Promise<ProjectCommunicationItem> {
    return apiClient.patch(`/api/v1/projects/${projectId}/communications/${itemId}`, body).then((r) => r.data)
  },
  delete(projectId: number, itemId: number): Promise<void> {
    return apiClient.delete(`/api/v1/projects/${projectId}/communications/${itemId}`)
  },
}
